module.exports = __webpack_public_path__ + "img/default_service.59a524bc.svg";